import { ApolloClient, HttpLink, InMemoryCache, NormalizedCacheObject } from '@apollo/client';
import { PropsWithChildren, useRef } from 'react';

import {
	WorkspaceProvider as BaseWorkSpaceProvider,
	useWorkspaceAlias,
} from '@treams/treams-hooks';
import { useWorkspaceAliasQuery } from '@treams/treams-network';

import FullPageLoadingContainer from '../packages/kakapo-ui-application/pages/loading/FullPageLoadingContainer';

export const WorkspaceProvider = ({ children }: PropsWithChildren) => {
	const client = useRef<ApolloClient<NormalizedCacheObject> | undefined>(undefined);

	if (!client.current) {
		client.current = new ApolloClient({
			cache: new InMemoryCache(),
			link: new HttpLink({
				uri: import.meta.env.VITE_GRAPHQL_ENDPOINT ?? 'https://api.ontreams.com/graphql',
				fetch: (info, init) => fetch(info, init),
			}),
		});
	}

	const alias = useWorkspaceAlias();
	const { data } = useWorkspaceAliasQuery({ client: client.current, variables: { alias } });
	const workspace = data?.workspaceAlias ? { id: data.workspaceAlias.id } : undefined;

	return workspace ? (
		<BaseWorkSpaceProvider value={workspace}>{children}</BaseWorkSpaceProvider>
	) : (
		<FullPageLoadingContainer />
	);
};
